import React from 'react';
import { CheckIcon } from 'src/components';

type Props = {
  testID?: string;
  active?: boolean;
  label: string;
};

export const StepIndicatorItem: React.FC<Props> = ({ label, active, testID = 'StepIndicatorItem' }) => {
  const activeClasses = active ? 'bg-dark text-white w-6 h-6' : 'bg-transparent text-white border-4 w-5 h-5';

  return (
    <div data-testid={testID} className={`rounded-full  flex justify-center items-center ${activeClasses}`}>
      {active ? <CheckIcon color="white" height={10} /> : null}
    </div>
  );
};
